import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Select/sgds-select";
import { register } from "../../utils/ce-registry";

register("sgds-select", Component);

export default createComponent({
  react: React,
  tagName: "sgds-select",
  elementClass: Component,
  events: {
    onSgdsSelect: "sgds-select",
    onSgdsChange: "sgds-change",
    onSgdsFocus: "sgds-focus",
    onSgdsBlur: "sgds-blur",
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
